import { gql} from "@apollo/client";

export const GET_ALL_EQUIPMENT_CATEGORIES_FOR_SELECT_FIELD = gql`

    query {
        allEquipmentCategories {
            id
            name
        }
    }
`